import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "32491468280";
const WHATSAPP_MESSAGE = "Hallo, ik heb een vraag over VdS Gift Shop.";

export default function WhatsAppButton() {
    const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
    return (
        <a
            data-testid="whatsapp-button"
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe58] text-white pl-3 pr-4 py-3 shadow-lg border border-[#128C7E]/30 transition-transform hover:scale-105"
            style={{ borderRadius: "999px" }}
            aria-label="WhatsApp ons"
        >
            <span className="flex items-center justify-center w-7 h-7 bg-white/15 rounded-full">
                <MessageCircle size={16} fill="white" stroke="white" />
            </span>
            <span className="text-xs font-bold uppercase tracking-widest hidden sm:inline">Vraag?</span>
        </a>
    );
}
